import { render } from "./suppliers.vue?vue&type=template&id=222cfb5a&scoped=true"
import script from "./suppliers.vue?vue&type=script&lang=js"
export * from "./suppliers.vue?vue&type=script&lang=js"

import "./suppliers.vue?vue&type=style&index=0&id=222cfb5a&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222cfb5a"]])

export default __exports__